import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			className: "frontCircle",
			x: 2,
			y: 2,
			width: 32,
			height: 32,
			rx: 16,
			fill: "#4051BF"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_975_63614)",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon",
				d: "M17.9999 20.6663V17.9997M17.9999 15.333H18.0066M24.6666 17.9997C24.6666 21.6816 21.6818 24.6663 17.9999 24.6663C14.318 24.6663 11.3333 21.6816 11.3333 17.9997C11.3333 14.3178 14.318 11.333 17.9999 11.333C21.6818 11.333 24.6666 14.3178 24.6666 17.9997Z",
				stroke: "#9FA8DF",
				strokeWidth: 1.33,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "bgCircle",
			x: 2,
			y: 2,
			width: 32,
			height: 32,
			rx: 16,
			stroke: "#1A204D",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_975_63614",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(10 10)"
			})
		}) })
	]
});
export default SvgInfo;
